<template>
  <div class="volume-wrapper flexrow">
    <button-simple
      class="mute-button flexrow-item"
      :title="muted ? $t('playlists.actions.unmute') : $t('playlists.actions.mute')"
      :icon="muted ? 'soundoff' : 'soundon'"
      @click="$emit('mute-toggle')"
    />
    <div
      v-show="isOpen"
      class="volume-background flexrow-item"
    >
      <input
        min="0"
        max="100"
        class="volume-slider"
        type="range"
        :value="muted ? 0 : volume"
        @input="onSetVolume"
      />
    </div>
  </div>
</template>

<script>
import ButtonSimple from '@/components/widgets/ButtonSimple'
import { emit } from 'superagent';

export default {
  name: 'volume-picker',

  components: {
    ButtonSimple,
  },

  props: {
    muted: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      volume: 50,
      isOpen: true,
    }
  },

  computed: {},

  methods: {
    onSetVolume (event) {
      if (this.muted) { this.$emit('mute-toggle') }
      this.$emit('volume-set', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.volume-wrapper {
  position: relative;
}

.mute-button {
  margin: 0;
  background: none;
  border: 0;
  border-radius: 0;
  color: var(--text);
}

.volume-background {
  width: 8em;
  background: none;
}

.volume-slider {
  width: 7.5em;
  margin-left: 0.25em;
  margin-right: 0.25em;
  margin-top: 0.25em;
}
</style>
